import React from 'react';
import { cn } from '../../design-system/cn';
import { SPORT_EMBLEMS } from '../../assets/sports/SportEmblems';
import { SPORT_MARK_IMAGES } from '../../assets/sports/sportMarks';

const SIZES = {
  xs: 'h-8 w-8',
  sm: 'h-10 w-10',
  md: 'h-14 w-14',
  lg: 'h-16 w-16',
  xl: 'h-20 w-20',
  hero: 'h-40 w-40 md:h-52 md:w-52',
};

/**
 * Sport emblem — LockedIn photoreal neon-ring marks (preferred),
 * with SVG fallback if a photo mark is not registered.
 * Compact inline chrome should keep SportIcon.
 */
export default function SportEmblemDisplay({
  iconId = 'generic',
  size = 'md',
  className,
  style,
}) {
  const sizeClass = SIZES[size] || SIZES.md;
  const photoSrc = SPORT_MARK_IMAGES[iconId] || (!SPORT_EMBLEMS[iconId] ? SPORT_MARK_IMAGES.generic : null);

  if (photoSrc) {
    return (
      <span
        className={cn('inline-flex shrink-0 items-center justify-center', sizeClass, className)}
        style={style}
        data-sport-emblem-id={iconId}
        data-sport-mark="photo"
      >
        <img
          src={photoSrc}
          alt=""
          draggable={false}
          className="h-full w-full object-contain select-none"
          data-sport-icon-id={iconId}
          aria-hidden
        />
      </span>
    );
  }

  const Emblem = SPORT_EMBLEMS[iconId] || SPORT_EMBLEMS.generic;
  return (
    <span
      className={cn('inline-flex shrink-0 items-center justify-center', sizeClass, className)}
      style={style}
      data-sport-emblem-id={iconId}
      data-sport-mark="svg"
    >
      <Emblem className="h-full w-full" data-sport-icon-id={iconId} aria-hidden />
    </span>
  );
}
